/* WC — Mobile nav: drill-down panels inside the header drawer. */
(function () {
  'use strict';

  var MOBILE = '(max-width: 767px)';

  function init(root) {
    if (!root || root.dataset.wcMnavReady === 'true') return;
    root.dataset.wcMnavReady = 'true';

    var track = root.querySelector('[data-wc-mnav-track]');
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-wc-panel]'));
    if (!track || !panels.length) return;

    var order = ['root'];

    function indexOfPanel(id) {
      for (var i = 0; i < panels.length; i++) {
        if (panels[i].dataset.wcPanel === id) return i;
      }
      return -1;
    }

    function show(id) {
      var idx = indexOfPanel(id);
      if (idx < 0) return;

      panels.forEach(function (panel, i) {
        var active = i === idx;
        panel.classList.toggle('is-active', active);
        panel.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (active) {
          panel.removeAttribute('inert');
          panel.scrollTop = 0;
        } else {
          panel.setAttribute('inert', '');
        }
        panel.querySelectorAll('a, button').forEach(function (el) {
          el.setAttribute('tabindex', active ? '0' : '-1');
        });
      });

      track.style.transform = 'translateX(-' + idx * 100 + '%)';
    }

    root.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-wc-open]');
      if (opener && root.contains(opener)) {
        event.preventDefault();
        order.push(opener.dataset.wcOpen);
        show(opener.dataset.wcOpen);
        return;
      }

      var back = event.target.closest('[data-wc-back]');
      if (back && root.contains(back)) {
        event.preventDefault();
        if (order.length > 1) order.pop();
        show(order[order.length - 1]);
      }
    });

    // reset to root whenever the drawer is closed
    var drawer = root.closest('#cast-drawer-nav');
    if (drawer && 'MutationObserver' in window) {
      new MutationObserver(function () {
        var open =
          drawer.classList.contains('is-open') ||
          drawer.classList.contains('active') ||
          drawer.getAttribute('aria-hidden') === 'false' ||
          drawer.hasAttribute('open');
        if (!open && order.length > 1) {
          order = ['root'];
          show('root');
        }
      }).observe(drawer, { attributes: true, attributeFilter: ['class', 'aria-hidden', 'open'] });
    }

    show('root');
  }

  function boot() {
    if (!window.matchMedia(MOBILE).matches) return;
    document.querySelectorAll('[data-wc-mnav]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.matchMedia(MOBILE).addEventListener('change', boot);
  document.addEventListener('shopify:section:load', boot);
})();
